<template lang="html">
<div>
      <div class="subpage affairs1">

            <div class="text-block clearfix">
                <div class="bName">上级事项</div>
                <div class="bContent">
                      <el-select
                          class="inpLoc"
                          v-model="params.pid"
                          filterable
                          remote
                          clearable
                          reserve-keyword
                          placeholder="输入上级事项名称"
                          :remote-method="upSeek"
                          @change="upSelect"
                          :loading="loading">
                          <el-option
                            v-for="item in selectArr"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                          </el-option>
                      </el-select>
                      <span class="tips">无上级事项时不用填写此项</span>
                </div>
            </div>

            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                <div class="text-block clearfix">
                    <div class="bName">标题</div>
                    <div class="bContent">
                          <el-form-item prop="title">
                                <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入内容"></el-input>
                          </el-form-item>
                    </div>
                </div>
                <div class="selects">
                      <div class="select-line">

                          <div class="selectGp">
                                <span>主题分类</span>
                                <el-form-item prop="topicClassificationId">
                                    <dic-select code="ztfl"
                                         :selectId="params.topicClassificationId"
                                         paramsKey="topicClassification"
                                         @selectChange="selectChange"/>
                                </el-form-item>

                          </div>
                          <div class="selectGp">
                                <span>部门分类</span>
                                <el-form-item prop="topicClassificationId">
                                    <dic-select code="bmfl"
                                         :selectId="params.departmentClassificationId"
                                         paramsKey="departmentClassification"
                                         @selectChange="selectChange"/>
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span class="leftPad">生命周期分类</span>
                                <el-form-item prop="topicClassificationId">
                                    <dic-select code="smzqfl"
                                         :selectId="params.lifeCycleClassificationId"
                                         paramsKey="lifeCycleClassification"
                                         @selectChange="selectChange" />
                                </el-form-item>
                          </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>事项类型</span>
                              <el-form-item prop="topicClassificationId">
                                  <dic-select code="sxlx"
                                       :selectId="params.matterClassificationId"
                                       paramsKey="matterClassification"
                                       @selectChange="selectChange" />
                              </el-form-item>

                        </div>

                        <div class="selectGp">
                              <span>实施主体</span>
                              <el-form-item prop="implementationSubject">
                                  <el-input class="inpText" v-model="params.implementationSubject" size="medium" placeholder="实施主体" ></el-input>
                              </el-form-item>
                        </div>

                        <div class="selectGp">
                              <span>服务对象</span>
                              <el-form-item prop="serviceObjectId">
                                  <all-select code="fwdx"
                                       :selectId="params.serviceObjectId"
                                       paramsKey="serviceObject"
                                       @selectChange="selectChange"/>
                              </el-form-item>
                        </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>法定期限</span>
                              <el-form-item prop="legalPeriod">
                                  <el-input-number size="medium" :precision="1" :step="0.5" v-model="params.legalPeriod"></el-input-number>
                              </el-form-item>
                              <span>个工作日</span>
                        </div>

                        <div class="selectGp">
                              <span>承诺期限</span>
                              <el-form-item prop="commitmentPeriod">
                                  <el-input-number size="medium" :precision="1" :step="0.5" v-model="params.commitmentPeriod"></el-input-number>
                              </el-form-item>
                              <span>个工作日</span>
                        </div>

                        <div class="selectGp">
                              <span>咨询电话</span>
                              <el-form-item prop="supportHotline">
                                  <el-input class="inpText" v-model="params.supportHotline" size="medium"></el-input>
                              </el-form-item>
                        </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>监督电话</span>
                              <el-form-item prop="monitorTelephone">
                                  <el-input class="inpText" v-model="params.monitorTelephone" size="medium"></el-input>
                              </el-form-item>
                        </div>
                        <div class="selectGp">
                              <span>申报网址</span>
                              <el-form-item prop="url">
                                  <el-input class="inpText" v-model="params.url" size="medium"></el-input>
                              </el-form-item>
                        </div>

                      </div>

                </div>

                <div class="text-block clearfix">
                    <div class="bName">申报地址</div>
                    <div class="bContent">
                          <el-form-item prop="declarationAddress">
                              <ads-select :adsList="adsStore" @selected="mapChange"  selectType="1"/>
                          </el-form-item>
                    </div>
                </div>


                <div class="text-block clearfix">
                    <div class="bName" style="padding-top:30px;">办理时间</div>
                    <div class="bContent">
                         <div>
                             <span>上午：</span>
                             <el-time-picker
                               v-model="startTm"
                               is-range
                               start-placeholder="开始时间"
                               end-placeholder="结束时间"
                               format="HH:mm"
                               value-format="HH:mm"
                               placeholder="选择时间">
                             </el-time-picker>
                         </div>

                         <div style="margin-top:12px;">
                             <span>下午：</span>
                             <el-time-picker
                               v-model="endTm"
                               is-range
                               start-placeholder="开始时间"
                               end-placeholder="结束时间"
                               format="HH:mm"
                               value-format="HH:mm"
                               placeholder="选择时间">
                             </el-time-picker>
                         </div>

                    </div>
                </div>

                <div class="text-block loc-block clearfix">
                    <div class="bName">办理地点</div>
                    <div class="bContent">
                         <ads-select :adsList="locArr" ref="adsSelect"/>
                    </div>
                </div>


                <div class="text-block textarea clearfix">
                    <div class="bName">受理条件</div>
                    <div class="bContent">
                        <el-input
                            type="textarea"
                            :rows="5"
                            @input="textChange(1)"
                            placeholder="请输入内容"
                            v-model="areaText1">
                        </el-input>
                        <span class="tips">多条内容请使用回车换行</span>
                    </div>
                </div>

                <div class="text-block textarea clearfix">
                    <div class="bName">办理条件</div>
                    <div class="bContent">
                        <el-input
                            type="textarea"
                            :rows="5"
                            @input="textChange(2)"
                            placeholder="请输入内容"
                            v-model="areaText2">
                        </el-input>
                        <span class="tips">多条内容请使用回车换行</span>
                    </div>
                </div>
            </el-form>
            <div class="enclosure">
                 <div class="ttl">附件</div>
                 <div class="ecContent">
                      <file-upload :files="params.fileId" @fileChange="fileChange" />
                 </div>
            </div>


      </div>
</div>
</template>

<script>

import { getAffair, getUpList } from "@/api/affairs/affairs";

export default {
  props: ['affid'],
  data() {
    return {
      options: [],
      selectArr: [],

      locArr: [],

      areaText1: '',   // 受理条件
      textArr1: [],

      areaText2: '',   // 办理条件
      textArr2: [],

      adsStore: [],

      startTm: ['09:00', '11:30'],
      endTm: ['12:30', '17:00'],

      params: {

        pid: '',  // 
        ptitle: '', //  事项名称
        level: '', // 层级关系
        type: '',  // 事项类型

        status: '',
        sort: '',

        title: '',
        topicClassification: '',  // 主题分类
        topicClassificationId: '',

        departmentClassification: '',  // 部门分类
        departmentClassificationId: '',

        lifeCycleClassification: '', // 生命周期
        lifeCycleClassificationId: '',

        matterClassification: '',  // 事项类型
        matterClassificationId: '',

        implementationSubject: '', // 实施主体
        implementationSubjectId: '',

        serviceObject: '',  // 服务对象
        serviceObjectId: '',

        legalPeriod: '', // 法定期限
        commitmentPeriod: '', // 承诺期限
        supportHotline: '', // 咨询电话
        monitorTelephone: '', // 监督电话

        declarationAddress: '', // 申报地址
        latitude: '',
        longitude: '',
        url: '', // 申报网址

        processingTimeStart: '',
        processingTimeEnd: '',

        fileId: ''  //  附件


      },

      rules: {
        title: [{
          required: true,
          trigger: 'blur'
        }],
        topicClassificationId: [{
          required: true,
          trigger: 'change'
        }],
        departmentClassificationId: [{
          required: true,
          trigger: 'change'
        }],
        lifeCycleClassificationId: [{
          required: true,
          trigger: 'change'
        }],
        matterClassificationId: [{
          required: true,
          trigger: 'change'
        }],
        implementationSubject: [{
          required: true,
          trigger: 'change'
        }],
        serviceObjectId: [{
          required: true,
          trigger: 'change'
        }],
        legalPeriod: [{
          required: true,
          trigger: 'change'
        }],
        commitmentPeriod: [{
          required: true,
          trigger: 'change'
        }],
        supportHotline: [{
          required: true,
          trigger: 'change'
        }],
        monitorTelephone: [{
          required: true,
          trigger: 'change'
        }],
        declarationAddress: [{
          required: true,
          trigger: 'blur'
        }],
        url: [{
          required: true,
          trigger: 'change'
        }],
        processingTimeStart: [{
          required: true,
          trigger: 'change'
        }],
        processingTimeEnd: [{
          required: true,
          trigger: 'change'
        }],
      }
    }
  },
  methods: {
    upSeek: function (e) {    //  上级事项查询
      var vues = this;
      getUpList({
        level: 1,
        size: 60,
        no: 1,
        keyword: e,
      }).then(res => {
        vues.selectArr = res.handleMattersList;
      })
    },
    upSelect: function (e) {        // 上级事项筛选
      if (e) {
        this.params.level = 1;
        this.selectArr.forEach(item => {
          if (item.id == e) {
            this.params.ptitle = item.title;
            return false;
          }
        })
      } else {
        this.params.level = '';
      }
    },

    selectChange: function (eDat) {
      this.params[eDat.paramsKey] = eDat.name;
      this.params[eDat.paramsKey + 'Id'] = eDat.id;
    },

    textChange: function (paramKey) {    //  受理、办理条件
      var vues = this;

      var unFormate = vues['areaText' + paramKey].split(/\n/);
      var textArr = [];
      unFormate.forEach((item, i) => {
        if (item) {
          textArr.push({
            content: item,
            cqjZhengwuHandleMattersId: vues.affid
          });
        }
      });

      vues['textArr' + paramKey] = textArr;

    },

    addressTrans: function (list, type) {
      var newArr = [];
      list.forEach((item, i) => {
        if (type == 1) {
          newArr.push({
            content: item.name + ',' + item.address,
            cqjZhengwuHandleMattersId: this.affid,
            longitude: item.latLng.lng,
            latitude: item.latLng.lat
          })
        } else if (type == 2) {
          newArr.push({
            name: item.content.split(',')[0],
            address: item.content.split(',')[1],
            latLng: {
              lng: item.longitude,
              lat: item.latitude
            }
          })
        }
      });
      return newArr;
    },

    mapChange: function (e) {    //  位置地点
      this.params.declarationAddress = e.name + ',' + e.address;
      this.params.latitude = e.latLng.lat;
      this.params.longitude = e.latLng.lng;
    },

    fileChange: function (e) {    //  附件
      if (e.length > 0) {
        this.params.fileId = JSON.stringify(e);
      } else {
        this.params.fileId = '';
      }

    },

    saveReturn: function () {
      var vues = this;
      return new Promise((reslove, reject) => {
        vues.$refs.ruleForm.validate((valid) => {
          var posts = [this.addressTrans(vues.$refs.adsSelect.selectedList, 1), vues.textArr1, vues.textArr2];
          if (valid) {
            vues.params.processingTimeStart = vues.startTm.join(',');
            vues.params.processingTimeEnd = vues.endTm.join(',');
            posts.unshift(vues.params)
            reslove(posts);
          } else {
            posts.unshift(false)
            reslove(posts);
          }
        })
      })

    },

    preEdit: function (res) {
      var unFormate = res.handleMatters;
      for (var key in this.params) {
        if (unFormate[key]) {
          this.params[key] = unFormate[key];
        };

        // 办理地点
        this.locArr = this.addressTrans(res.handleAddressList, 2);
        var addr = this.params.declarationAddress.split(',');
        // 申报地址
        this.adsStore = [{
          name: addr[0],
          address: addr[1],
          latLng: {
            lng: this.params.longitude,
            lat: this.params.latitude
          }
        }];
        console.log(this.adsStore);
        // 受理条件
        this.textArr1 = res.acceptanceConditionsList;
        var arr1 = [];
        this.textArr1.forEach(item => {
          arr1.push(item.content);
        });
        this.areaText1 = arr1.join('\n');

        // 办理条件
        this.textArr2 = res.processConditionsList;
        var arr2 = [];
        this.textArr2.forEach(item => {
          arr2.push(item.content);
        });
        this.areaText2 = arr2.join('\n');
        // 办理时间
        if (res.handleMatters.processingTimeStart && res.handleMatters.processingTimeStart.split(',').length > 1) {
          this.startTm = res.handleMatters.processingTimeStart.split(',');
        }
        if (res.handleMatters.processingTimeEnd && res.handleMatters.processingTimeEnd.split(',').length > 1) {
          this.endTm = res.handleMatters.processingTimeEnd.split(',');
        }


      }

      this.upSeek(unFormate.ptitle);

    }
  },
  created: function () {

    var querys = this.$route.query;

  }
}
</script>

<style lang="scss" scoped>
.selects {
  .select-line {
    position: relative;
    margin-bottom: 20px;
    .selectGp {
      display: inline-block;
      width: 32%;
      span {
        font-size: 14px;
        margin-right: 15px;
      }

      .leftPad {
        margin-left: -30px;
      }
    }
  }
}

.text-block {
  font-size: 14px;
  .bName {
    width: 60px;
    padding-top: 6px;
    float: left;
  }
  .bContent {
    margin-left: 75px;
    position: relative;
    margin-bottom: 20px;

    .tips {
      font-size: 12px;
      color: #aeaeae;
      margin-top: 12px;
      margin-left: 12px;
    }

    .minspan {
      margin: 0 6px;
    }

    .inpLoc {
      width: 475px;
    }

    .locLine {
      margin-top: 12px;
      .remove-btn {
        color: salmon;
        margin-left: 12px;
        cursor: pointer;
      }
    }
  }
}

.loc-block {
  margin-top: 30px;
  margin-bottom: 30px;
}

.text-block.textarea {
  .bName {
    margin-top: -8px;
  }
  .bContent {
    .el-textarea {
      width: 50%;
      vertical-align: text-top;
    }
  }
}

.enclosure {
  margin-top: 60px;
  .ttl {
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent {
    margin-left: 75px;
  }
}
</style>

<style lang="css">
.subpage.affairs1 .el-input__inner {
  border-radius: 0px !important;
}

.subpage.affairs1 .inpText {
  width: 240px !important;
}

.subpage.affairs1 .el-form-item {
  display: inline-block !important;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// Subpage1.vue?5d5bbcda